<template>
  <div class="add-ask-or-iq-btn">
    <Button
      v-if="showAddButton"
      :normal="'normal-hover'"
      :label="empLabel"
      :icon="'add-icon.svg'"
      :disabled="disabled"
      @onClick="handleButtonClick"
    ></Button>
    <v-btn
      :class="[
        'add-ask-light-button',
        isObjectHovered && !disabled ? 'add-ask-hover-object' : '',
      ]"
      class="add-ask-iq-button d-flex align-center justify-space-between"
      :disabled="disabled"
      @mouseenter="onHoverObject"
      @mouseleave="onLeaveObject"
      @click="handleAIClick"
      v-if="showAIButton"
    >
      <div class="add-ask-iq-icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="20" height="20" rx="3.75" fill="#ED2738" />
          <path
            d="M16.1392 9.68748C16.1392 10.8551 15.77 11.8681 15.0317 12.7266L15.9589 13.6924L14.6969 14.8128L13.7182 13.7955C13.0228 14.1818 12.2673 14.375 11.4517 14.375C10.1553 14.375 9.05216 13.9242 8.14214 13.0228C7.23211 12.1128 6.7771 11.001 6.7771 9.68748C6.7771 8.37396 7.23211 7.26648 8.14214 6.36504C9.05216 5.45501 10.1553 5 11.4517 5C12.7481 5 13.8512 5.45501 14.7613 6.36504C15.6799 7.26648 16.1392 8.37396 16.1392 9.68748ZM11.4517 12.6365C11.7865 12.6365 12.1213 12.5807 12.4562 12.4691L10.9752 10.9237L12.2372 9.80338L13.8212 11.4517C14.1818 10.9366 14.3621 10.3485 14.3621 9.68748C14.3621 8.82897 14.083 8.1207 13.525 7.56266C12.967 7.00463 12.2759 6.72561 11.4517 6.72561C10.6275 6.72561 9.93643 7.00463 9.37839 7.56266C8.82036 8.1207 8.54134 8.82897 8.54134 9.68748C8.54134 10.5374 8.82036 11.2414 9.37839 11.7994C9.93643 12.3575 10.6275 12.6365 11.4517 12.6365Z"
            fill="white"
          />
          <path d="M3.75 5.17969H5.52712V14.1941H3.75V5.17969Z" fill="white" />
        </svg>
      </div>
      <div class="ml-2 add-ask-label-icon">
        <svg
          width="12"
          height="16"
          viewBox="0 0 12 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.65779 6.24746C6.76779 5.91746 7.23379 5.91746 7.34379 6.24746L7.98879 8.18446C8.13076 8.61026 8.36996 8.99714 8.68743 9.31444C9.0049 9.63173 9.39191 9.87072 9.81779 10.0125L11.7538 10.6575C12.0838 10.7675 12.0838 11.2335 11.7538 11.3435L9.81679 11.9885C9.39099 12.1304 9.0041 12.3696 8.68681 12.6871C8.36951 13.0046 8.13053 13.3916 7.98879 13.8175L7.34379 15.7535C7.32007 15.8257 7.27414 15.8886 7.21255 15.9333C7.15095 15.9779 7.07684 16.0019 7.00079 16.0019C6.92473 16.0019 6.85062 15.9779 6.78903 15.9333C6.72743 15.8886 6.6815 15.8257 6.65779 15.7535L6.01279 13.8165C5.87092 13.3908 5.63187 13.004 5.31458 12.6867C4.99729 12.3694 4.61048 12.1303 4.18479 11.9885L2.24779 11.3435C2.17553 11.3197 2.1126 11.2738 2.06799 11.2122C2.02338 11.1506 1.99936 11.0765 1.99936 11.0005C1.99936 10.9244 2.02338 10.8503 2.06799 10.7887C2.1126 10.7271 2.17553 10.6812 2.24779 10.6575L4.18479 10.0125C4.61048 9.87059 4.99729 9.63154 5.31458 9.31425C5.63187 8.99696 5.87092 8.61015 6.01279 8.18446L6.65779 6.24746ZM2.79479 1.14846C2.80913 1.10515 2.83675 1.06747 2.87373 1.04076C2.91071 1.01405 2.95517 0.999669 3.00079 0.999669C3.04641 0.999669 3.09086 1.01405 3.12784 1.04076C3.16482 1.06747 3.19245 1.10515 3.20679 1.14846L3.59379 2.31046C3.76679 2.82846 4.17279 3.23446 4.69079 3.40746L5.85279 3.79446C5.89609 3.8088 5.93378 3.83642 5.96049 3.8734C5.9872 3.91038 6.00157 3.95484 6.00157 4.00046C6.00157 4.04607 5.9872 4.09053 5.96049 4.12751C5.93378 4.16449 5.89609 4.19212 5.85279 4.20646L4.69079 4.59346C4.43516 4.6783 4.20288 4.82165 4.01243 5.0121C3.82198 5.20255 3.67863 5.43483 3.59379 5.69046L3.20679 6.85246C3.19245 6.89576 3.16482 6.93345 3.12784 6.96016C3.09086 6.98687 3.04641 7.00124 3.00079 7.00124C2.95517 7.00124 2.91071 6.98687 2.87373 6.96016C2.83675 6.93345 2.80913 6.89576 2.79479 6.85246L2.40779 5.69046C2.32295 5.43483 2.1796 5.20255 1.98915 5.0121C1.7987 4.82165 1.56641 4.6783 1.31079 4.59346L0.148787 4.20646C0.105481 4.19212 0.0677964 4.16449 0.0410864 4.12751C0.0143764 4.09053 0 4.04607 0 4.00046C0 3.95484 0.0143764 3.91038 0.0410864 3.8734C0.0677964 3.83642 0.105481 3.8088 0.148787 3.79446L1.31079 3.40746C1.56641 3.32262 1.7987 3.17927 1.98915 2.98882C2.1796 2.79837 2.32295 2.56608 2.40779 2.31046L2.79479 1.14846ZM9.86379 0.0994558C9.87366 0.0709821 9.89216 0.0462917 9.91671 0.0288174C9.94126 0.011343 9.97065 0.00195312 10.0008 0.00195312C10.0309 0.00195313 10.0603 0.011343 10.0849 0.0288174C10.1094 0.0462917 10.1279 0.0709821 10.1378 0.0994558L10.3958 0.873456C10.5108 1.21946 10.7818 1.49046 11.1278 1.60546L11.9018 1.86346C11.9303 1.87333 11.955 1.89183 11.9724 1.91638C11.9899 1.94093 11.9993 1.97032 11.9993 2.00046C11.9993 2.03059 11.9899 2.05998 11.9724 2.08453C11.955 2.10909 11.9303 2.12758 11.9018 2.13746L11.1278 2.39546C10.9574 2.45246 10.8026 2.54824 10.6756 2.67527C10.5486 2.8023 10.4528 2.9571 10.3958 3.12746L10.1378 3.90146C10.1279 3.92993 10.1094 3.95462 10.0849 3.9721C10.0603 3.98957 10.0309 3.99896 10.0008 3.99896C9.97065 3.99896 9.94126 3.98957 9.91671 3.9721C9.89216 3.95462 9.87366 3.92993 9.86379 3.90146L9.60579 3.12746C9.54879 2.9571 9.453 2.8023 9.32597 2.67527C9.19894 2.54824 9.04415 2.45246 8.87379 2.39546L8.10079 2.13746C8.07231 2.12758 8.04762 2.10909 8.03015 2.08453C8.01267 2.05998 8.00328 2.03059 8.00328 2.00046C8.00328 1.97032 8.01267 1.94093 8.03015 1.91638C8.04762 1.89183 8.07231 1.87333 8.10079 1.86346L8.87479 1.60546C9.22079 1.49046 9.49179 1.21946 9.60679 0.873456L9.86379 0.0994558Z"
            fill="#7F56D9"
          />
        </svg>
        <p class="mb-0 ms-1 add-ask-label">{{ label }}</p>
      </div>
    </v-btn>
  </div>
</template>

<script setup>
import { ref } from "vue";
import Button from "@components/buttons/Button.vue";

const emit = defineEmits([ "add", "addAI"]);

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  empLabel: {
    type: String,
    required: true,
  },
  showAddButton: {
    type: Boolean,
    default: true,
  },
  showAIButton: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const isObjectHovered = ref(false);
const isAskAiHovered = ref(false);

const onHoverObject = () => {
  if (props.disabled) return;
  if (!isAskAiHovered.value) {
    isObjectHovered.value = true;
  }
};

const onLeaveObject = () => {
  isObjectHovered.value = false;
};

const handleButtonClick = () => {
  if (props.disabled) return;
  emit("add");
};

const handleAIClick = () => {
  if (props.disabled) return;
  emit("addAI");
};
</script>

<style scoped>
.add-ask-or-iq-btn {
  display: flex;
  gap: 5px;
  align-items: center;
}
.add-ask-iq-button {
  border-radius: 8px !important;
  height: 40px !important;
  border-width: 1px;
  padding: 8px 8px 8px 12px !important;
  gap: 10px !important;
  min-width: 200px;
  box-shadow: none !important;
  border: 1px solid #7f56d9;
  box-shadow: 0px 1px 2px 0px #1018280d;
}
.add-ask-light-button {
  background-color: #f2edff !important;
}
.add-ask-hover-object.add-ask-light-button {
  background-color: #e4dbfc !important;
}
.add-ask-label {
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  vertical-align: middle;
  color: #7f56d9;
  text-transform: capitalize;
}
.add-ask-iq-icon {
  position: relative;
  left: -5px;
  top: 2px;
}
.add-ask-label-icon {
  display: flex;
  align-items: center;
}
</style>
